import React, {Component} from 'react';

class Radio extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked || false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== undefined && nextProps.checked !== this.state.checked) {
      this.setState({checked: nextProps.checked});
    }
  }

  onChange = (event) => {
    const {checked} = event.target;
    this.setState({checked});
    this.props.onChange(checked, event);
  }

  render() {
    const {children, ...rest} = this.props;
    return (
      <React.Fragment>
        <input {...rest} type="radio" checked={this.state.checked} onChange={this.onChange}/>
          {children &&
            <label htmlFor={this.props.id} style={{width:'100%'}}>
              {children}
            </label>}
      </React.Fragment>
    );
  }
}


export default Radio;
